import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class UserAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser:any = this.authenticationService.currentUser();
    if (currentUser && currentUser.userType != null) {
      return true;
    } else if (currentUser && currentUser.userType === null) {
      this.router.navigate(['/new-user']);
    }
  }
}
